
<template>

<div class="">

    <div class="basic-margin">
        <el-row >
            <el-col :span="24">

                <el-col :span="24">

                  <quill-editor v-if="data.content.indexOf('<p>')!==-1" v-model="data.content"
                      ref="myQuillEditor"
                      :options="editorOption"
                      style="width:100%;height: 267pt; margin-bottom: 93px;margin-top:20px;"
                      >
                  </quill-editor>
                  <p v-else ><span style="font-size:20px;"><b>{{data.content}} </b></span></p>
                </el-col>

                  <el-col :span="24"  v-if="data.imgs">

                    <img v-for="img in data.imgs.split(',')" style="width:200px;margin-left:5px;" :src="img" alt=""></img>
                  </el-col>

            </el-col>
        </el-row>
        <el-row style="margin-top:10px;">

          <el-col :span="3">
              <p>{{data.nickName}} (
                  <span v-for="item in data.channels" >
                    {{item.channelPageName}}
                  </span>
                )</p>
          </el-col>
            <el-col :span="15">
                <template  v-if="data.categoryText">
                  <el-tag v-for="typeText in data.categoryText.split(',')" style="margin-right:5px;" type="warning">{{typeText}}</el-tag>

                </template>
                <template  v-if="data.carCategoryText"  >
                  <el-tag style="margin-right:5px;" v-for="typeText in data.carCategoryText.split(',')" type="success">{{typeText}}</el-tag>

                </template>
            </el-col>

            <el-col :span="6">
                <p>{{data.createTime | dateTimeFormat}} | {{data.browseCount}} 浏览 | {{data.replyCount}} 个回帖 </p>
                <el-button type="text"  @click="addReply(data.userId,randomReplayId)">回复</el-button>
            </el-col>
        </el-row>

    </div>

    <hr>
    <div style="border-left: 10px solid #999;
    padding-left: 20px;
    margin-top: 20px;">
        全部回复
    </div>
    <hr>

    <list-template ref="list-template" :hasSearch="false" actionUrl="question/findQuestionReplysForAdmin.action" :queryParams="searchInfo">
        <template slot="item" scope="scope">
            <div class="basic-margin" style="margin-left:30px;" v-for="item in scope.datas">
                <el-row>

                    <img :src="item.senderUserHead" style="width:50px;height:50px;float:left;margin-right:10px;" alt=""></img>

                    <el-col :span="22">
                        <el-col :span="3" style="color:#71B5C6;    padding: 10px 15px;">
                            {{item.senderNickName}}
                        </el-col>
                        <el-col :span="17" style="color:#999999;    padding: 10px 15px;">
                            {{item.createTime|dateTimeFormat}}
                        </el-col>
                        <el-col :span="4">
                            <el-button type="text"  :disabled="item.del==1" @click="deleteQuestionReply(item.id)">{{item.del==1?'已删除':'删除'}}</el-button>

                            <el-button type="text" v-show="item.senderId!=-110"  @click="addReply(item.senderId,-110)">回复</el-button>
                        </el-col>
                        <el-col :span="24" style="padding: 10px 15px;">
                            <span >回复 <span style="color:#71B5C6;">{{item.receiverNickName}}</span></span> {{item.content}}
                        </el-col>
                    </el-col>
                </el-row>
                <hr/>

            </div>
        </template>
    </list-template>
</div>

</template>

<script>

import questionModel from '../../../framework/models/questionModel'
import BasicPager from '../../../mixins/BasicPager'
import ListTemplate from '../../../components/ListTemplate'
import { quillEditor } from 'vue-quill-editor'
import { quillRedefine } from 'vue-quill-editor-upload'
export default {
  name: 'question-detail',
  extends: BasicPager,
  data: function () {
    return {
      randomReplayId: -110,
      searchInfo: {
        questionId: null
      },
      data: {}
    }
  },
  components: {
    ListTemplate,
    quillEditor,
    quillRedefine
  },
  created: function () {
    this.selectRandomVest()
    this.searchInfo.questionId = this.$route.params.questionId
    this.loadQuestionInfo()
  },
  methods: {
    selectRandomVest: function () {
      let _this = this

      let params = {

      }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas) {
            _this.randomReplayId = dataInfo.datas.id
          }
        }
      }
      questionModel.selectRandomVest(_this, params, listener)
    },
    addReply: function (senderId, replyerId) {
      this.$prompt('请输入回复内容', '回复', {
        confirmButtonText: '发送',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        inputErrorMessage: '回复内容不能为空！'
      }).then(({ value }) => {
        let _this = this

        let params = {
          questionId: this.data.id,
          senderId: replyerId,
          receiverId: senderId,
          content: value,
          channelId: this.data.channelId
        }
        let listener = {
          success: function (dataInfo) {
            _this.$message({
              type: 'success',
              message: '发布成功!'
            })
            _this.$refs['list-template'].loadList()
          }
        }
        questionModel.addReply(_this, params, listener)
      })
    },
    deleteQuestionReply: function (questionReplyId) {
      this.$confirm('此操作将删除该回复, 是否继续?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let params = {
          questionReplyId: questionReplyId
        }
        let listener = {
          success: function (dataInfo) {
            _this.$message({
              type: 'success',
              message: '删除成功!'
            })
            _this.$refs['list-template'].loadList()
          }
        }
        questionModel.deleteQuestionReply(_this, params, listener)
      })
    },
    loadQuestionInfo: function () {
      let _this = this
      let params = {
        questionId: this.$route.params.questionId
      }
      let listener = {
        success: function (dataInfo) {
          _this.data = dataInfo.datas
        }
      }

      questionModel.selectQuestionInfo(_this, params, listener)
    }
  }
}

</script>
